<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    @select="v=>$emit('change',v)"
    placeholder="请选择发票类型"
    :clearable="clearable"
    idKey="InvoiceTypeId"
    labelKey="InvoiceTypeName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/invoiceType").default,
    };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.list({Status: 1}).then((res) => {
          // console.log(res.Data);
          this.$emit('getInvoiceTypeValue',res.Data)
          resolve({ Data: res.Data });
        });
      });
    },
  },
};
</script>

